import { Component } from '@angular/core';
import { OmpButtonLabelMaxLength, OmpLogOutBlockKey, OmpNavBlocks } from '../../order-management-portal.sections';
import { OmpSectionSettings } from '..';

// Fixed navigational blocks with inline label edit (pencil -> tick/cross). Icons + help are
// frontend-only; only the *_label values live in data.
@Component({
  selector: 'omp-nav-blocks-settings',
  templateUrl: './nav-blocks-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpNavBlocksSettingsComponent extends OmpSectionSettings {
  public navBlocks = OmpNavBlocks;
  public labelMaxLength = OmpButtonLabelMaxLength;

  public editingKey: string = null;
  private originalLabel = '';

  showIcon(block: any): boolean {
    let show = true;
    if (this.data && this.data.show_icons === false && block.dataKey !== OmpLogOutBlockKey) {
      show = false;
    }
    return show;
  }

  labelLength(key: string): number {
    let length = 0;
    if (this.data && this.data[key]) {
      length = this.data[key].length;
    }
    return length;
  }

  isOver(key: string): boolean {
    return this.labelLength(key) > this.labelMaxLength;
  }

  edit(block: any) {
    this.editingKey = block.dataKey;
    if (this.data) {
      this.originalLabel = this.data[block.dataKey];
    }
  }

  confirm() {
    this.editingKey = null;
    this.change.emit();
  }

  cancel(block: any) {
    if (this.data) {
      this.data[block.dataKey] = this.originalLabel;
    }
    this.editingKey = null;
  }
}
